<template functional>
  <main class="d-flex flex-column p-2 load-page">
    <!--
    ============================================================================
    Alerts
    ============================================================================
    -->
    <b-modal
      id="modal-alerts"
      modal-class="w-100 mw-100 h-100 mh-100 m-0 p-0"
      dialog-class="w-100 mw-100 h-100 mh-100 m-0 p-0"
      content-class="w-100 mw-100 h-100 mh-100"
      hide-footer
      scrollable
      :title="parent.$t('common.alerts')">
      <slot name="alerts"></slot>
    </b-modal>

    <!--
    ============================================================================
    Debug
    ============================================================================
    -->
    <b-modal
      id="modal-debug"
      modal-class="w-100 mw-100 h-100 mh-100 m-0 p-0"
      dialog-class="w-100 mw-100 h-100 mh-100 m-0 p-0"
      content-class="w-100 mw-100 h-100 mh-100"
      hide-footer
      scrollable
      :title="parent.$t('common.debug')">
      <slot name="debug"></slot>
    </b-modal>

    <!--
    ============================================================================
    Tabs
    ============================================================================
    -->
    <full-height-tabs pills refs="tabs" @input="$options.onTabChanged(listeners, $event)">
      <b-button
        :size="parent.isMdUp ? undefined : 'sm'"
        variant="warning"
        v-b-modal.modal-alerts
        class="float-left mr-2"
        v-if="$slots.alerts || !!$scopedSlots.alerts"
        slot="tabs-start">
        <i class="fa fa-fw fa-exclamation-triangle"></i>
        <span v-if="parent.isMdUp">&nbsp;{{ parent.$t('common.alerts') }}</span>
      </b-button>

      <slot name="tabs"></slot>
    </full-height-tabs>
    <!--
    ============================================================================
    Buttons
    ============================================================================
    -->
    <div class="buttons border-top border-secondary text-right pt-2">
      <slot name="buttons"></slot>
    </div>
  </main>
</template>
<script>
export default {
  functional: true,

  onTabChanged(listeners, ...args) {
    const cb = listeners && listeners['tab-changed'];
    if (cb) {
      cb(...args);
    }
  }
}
</script>
